import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-flex-lcr',
    templateUrl: './flex-left-center-right.component.html',
    styleUrls: ['./flex-left-center-right.component.css']
})
export class FlexLeftCenterRightComponent implements OnInit {
    @Input() ecpLeftWidth: number = 0;
    @Input() ecpRightWidth: number = 0;
    @Input() ecpLeftBg: string = '#ffffff';
    @Input() ecpBodyBg: string = '#ffffff';
    @Input() ecpRightBg: string = '#ffffff';
    @Input() ecpStyle: object = {};

    constructor() {
    }

    ngOnInit() {
    }

}
